import { action, createRequestTypes } from './base';

export const batchActionTypes = {
  GET_BATCHES: createRequestTypes('GET_BATCHES'),
  CREATE_BATCH: createRequestTypes('CREATE_BATCH'),
  GET_RESERVATIONS: createRequestTypes('GET_RESERVATIONS'),
};

/**
 *
 */
class BatchActions {
  /**
   * @param page
   * @param entityId
   * @param entityType
   * @param addressId
   */
  getBatches = (tenantProductId, batchNumber, batchId, page, limit, availableQuantity, tenantDepartmentId, productSkuId, departmentId, selectedTenant, startDateEpoch, endDateEpoch, expiryStartDateEpoch, expiryEndDateEpoch, inventoryLocation, category, expiryStatus, availableStock) => action(batchActionTypes.GET_BATCHES.REQUEST, {
    tenantProductId, batchNumber, batchId, page, limit, availableQuantity, tenantDepartmentId, productSkuId, departmentId, selectedTenant, startDateEpoch, endDateEpoch, expiryStartDateEpoch, expiryEndDateEpoch, inventoryLocation, category, expiryStatus, availableStock,
  });

  /**
   * @param getBatchesLoading
   * @param getTenantsLoading
   * @return {{type: *}}
   */
  getBatchesLoading = (getBatchesLoading) => action(batchActionTypes.GET_BATCHES.LOADING, {
    getBatchesLoading,
  });

  /**
   * @param addresses
   * @param type
   * @param tenants
   * @return {{type: *}}
   */
  getBatchesSuccess = (batches) => action(batchActionTypes.GET_BATCHES.SUCCESS, {
    batches,
  });

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  createBatch = (payload, callback) => action(batchActionTypes.CREATE_BATCH.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param createBatchLoading
   * @returns {{type: *}}
   */
  createBatchLoading = (createBatchLoading) => action(batchActionTypes.CREATE_BATCH.LOADING, {
    createBatchLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  getReservations = (payload, callback) => action(batchActionTypes.GET_RESERVATIONS.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param getReservationsLoading
   * @returns {{type: *}}
   */
  getReservationsLoading = (getReservationsLoading) => action(batchActionTypes.GET_RESERVATIONS.LOADING, {
    getReservationsLoading,
  })

  /**
   *
   * @param reservations
   * @returns {{type: *}}
   */
  getReservationsSuccess = (reservations) => action(batchActionTypes.GET_RESERVATIONS.SUCCESS, {
    reservations
  })
}

export default new BatchActions();
